"use client";

import type { CarouselApi } from "@workspace/frontend-ui";
import { useCallback, useEffect, useState } from "react";

// Auto-rotation for the banner carousels: tracks the selected snap and
// advances to the next slide every `delay` ms (0 disables rotation).
const useAutoRotate = (api: CarouselApi | undefined, delay: number) => {
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }
    const handleSelect = () => setSelected(api.selectedScrollSnap());
    handleSelect();
    api.on("select", handleSelect);
    return () => {
      api.off("select", handleSelect);
    };
  }, [api]);

  useEffect(() => {
    if (!api || !delay) {
      return;
    }
    const timer = setTimeout(() => {
      const next = (api.selectedScrollSnap() + 1) % api.scrollSnapList().length;
      api.scrollTo(next);
    }, delay);
    return () => clearTimeout(timer);
  }, [api, delay, selected]);

  const goTo = useCallback(
    (index: number) => {
      api?.scrollTo(index);
    },
    [api],
  );

  return { selected, goTo };
};

export default useAutoRotate;
